var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultAvatarLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f5f5f5;}.b{fill:none;stroke:#cccccd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:10px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-923 -211)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 115,
    cy: 115,
    r: 115,
    transform: "translate(928 216)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(928 216)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.753,106.23c-1.42-24.987-15.668-32.918-36.5-39.862-14.9-4.968-19.7-20.019-21.239-29.2",
    transform: "translate(94.322 97.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M70.76,37.161c-1.542,9.189-6.319,24.247-21.22,29.215C28.7,73.32,14.325,81.147,12.9,106.142",
    transform: "translate(28.886 97.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M60.366,106.077h0A38.365,38.365,0,0,1,22,67.712V52.366A38.365,38.365,0,0,1,60.366,14h0A38.365,38.365,0,0,1,98.731,52.366V67.712A38.365,38.365,0,0,1,60.366,106.077Z",
    transform: "translate(54.634 31.974)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 115,
    cy: 115,
    r: 115
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarLarge);
export default __webpack_public_path__ + "static/media/default-avatar-large.1afcf9beb42e4a677390e71ebe5ffd37.svg";
export { ForwardRef as ReactComponent };